const MB = 1024 * 1024;
export const MAX_BRAND_INPUT = 20 * MB;
export const MAX_BRAND_UPLOAD = 2 * MB;

// Prepare only the upload copy. PNG keeps transparent backgrounds and avoids
// JPEG artifacts around logo text. The original file on the device is unchanged.
export async function prepareBrandImage(file, kind = 'logo') {
  if (!file || !file.size) throw new Error('File gambar kosong. Pilih gambar lain.');
  if (file.size > MAX_BRAND_INPUT) throw new Error('File sumber maksimal 20 MB. Pilih gambar yang lebih kecil.');
  const supported = /^(image\/(png|jpeg|webp|x-icon|vnd\.microsoft\.icon))$/i;
  if (file.type ? !supported.test(file.type) : !/\.(png|jpe?g|webp|ico)$/i.test(file.name)) {
    throw new Error('Gunakan gambar PNG, JPG, WebP, atau ICO.');
  }
  let source, image, canvas;
  try {
    source = URL.createObjectURL(file);
    image = new Image();
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = () => reject(new Error('Gambar tidak dapat dibaca. Coba ekspor ulang sebagai PNG atau JPG.'));
      image.src = source;
    });
    const width = image.naturalWidth, height = image.naturalHeight;
    if (!width || !height || width * height > 40000000) {
      throw new Error('Resolusi gambar maksimal 40 megapiksel. Pilih gambar dengan resolusi lebih kecil.');
    }
    canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Browser tidak dapat memproses gambar. Coba muat ulang atau gunakan Chrome.');
    for (let maxSide = kind === 'favicon' ? 256 : 1024; maxSide >= 128; maxSide = Math.floor(maxSide / 2)) {
      const scale = Math.min(1, maxSide / Math.max(width, height));
      canvas.width = Math.max(1, Math.round(width * scale));
      canvas.height = Math.max(1, Math.round(height * scale));
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      if (!blob || !blob.size) throw new Error('Gambar gagal dikompres. Coba gambar lain.');
      if (blob.size <= MAX_BRAND_UPLOAD) {
        return new File([blob], `${kind}.png`, { type: 'image/png' });
      }
    }
    throw new Error('Gambar masih terlalu besar setelah dikompres. Coba gambar lain.');
  } finally {
    if (source) URL.revokeObjectURL(source);
    if (image) { image.onload = null; image.onerror = null; image.src = ''; }
    if (canvas) { canvas.width = 0; canvas.height = 0; }
  }
}
